import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import {
  Radio,
  Button,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import { fire } from "./Firebase/firebase";
import FileUploader from "react-firebase-file-uploader";

export default class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      password: "",
      personality: "",
      gender: "",
      size: "",
      user: null,
      isLoggedIn: false,
      avatar: "",
      isUploading: false,
      progress: 0,
      avatarURL: null,
      loginError: ""
    };

    this.register = this.register.bind(this);
    this.createDataBaseEntry = this.createDataBaseEntry.bind(this);
  }

//Create user with firebase's own method, then call function to create database entry
  register() {
    if (this.state.avatarURL != null) {
      fire
        .auth()
        .createUserWithEmailAndPassword(this.state.email, this.state.password)
        .then(u => {
          this.setState({
            isLoggedIn: true
          });
          this.createDataBaseEntry();
        })
        .catch(error => {
          console.log(error);
          window.confirm(error);
        });
    } else {
      this.setState({
        loginError: " Please choose a profile picture!"
      });
    }
  }

// Get states that were set in handleChange to create database entry
  createDataBaseEntry() {
    let uid = fire.auth().currentUser.uid;

    fire
      .database()
      .ref("users")
      .child(uid)
      .set({
        name: this.state.name,
        email: this.state.email,
        size: this.state.size,
        personality: this.state.personality,
        gender: this.state.gender,
        avatar_url: this.state.avatarURL,
        visibility: false
      })
      .catch(error => {
        console.log(error);
      });
    console.log("Entry made");
  }

  goBack =()=> {
    this.props.history.goBack();
  }

  handleSubmit = e => {
    e.preventDefault();
  };

  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  handleRadioChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  //https://www.npmjs.com/package/react-firebase-file-uploader
  handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });

  handleProgress = progress => this.setState({ progress });

  handleUploadError = error => {
    this.setState({ isUploading: false });
    console.error(error);
  };

  handleUploadSuccess = filename => {
    this.setState({ avatar: filename, progress: 100, isUploading: false });
    fire
      .storage()
      .ref("images")
      .child(filename)
      .getDownloadURL()
      .then(url => this.setState({ avatarURL: url }));
  };

  render() {
    // If app.js says that the user is authenticated, the user is directed to the dashboard
    if (this.props.authenticated === true) {
      return (
        <Redirect
          to={{
            pathname: "/dashboard",
            state: { authenticated: this.props.authenticated }
          }}
        />
      );
    }

    return (
      <div>
        <div className="register">
         <i onClick={this.goBack} id= "white" className="arrow left" />
          <h1 className="text-center" id="register-title">
            Register
          </h1>
      
          <div id="error">
            <p>{this.state.loginError}</p>
          </div>
          <form onSubmit={this.handleSubmit}>
            <FormGroup className="clear" bsSize="large">
              {this.state.isUploading && <p>Progress: {this.state.progress}</p>}
              {this.state.avatarURL && (
                <img alt="Dog avatar" id="avatar" src={this.state.avatarURL} />
              )}
              <FileUploader
                accept="image/*"
                name="avatar"
                randomizeFilename
                storageRef={fire.storage().ref("images")}
                onUploadStart={this.handleUploadStart}
                onUploadError={this.handleUploadError}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleProgress}
              />
              <ControlLabel>Your email</ControlLabel>
              <FormControl
                className="input-hover"
                id="email"
                //value={this.state.userEmail}
                onChange={this.handleChange}
                type="userEmail"
              />
            </FormGroup>

            <FormGroup bsSize="large">
              <ControlLabel>Your password</ControlLabel>
              <FormControl
                className="input-hover"
                id="password"
                //value={this.state.password}
                onChange={this.handleChange}
                type="password"
              />
            </FormGroup>

            <FormGroup bsSize="large">
              <ControlLabel>Your dogs name</ControlLabel>
              <FormControl
                className="input-hover"
                autoFocus
                id="name"
                //value={this.state.dogname}
                onChange={this.handleChange}
              />
            </FormGroup>

            <FormGroup>
              <ControlLabel>Sex</ControlLabel>
              <br />
              <Radio
                className="inline-block"
                value="male"
                name="gender"
                onChange={this.handleRadioChange}
              >
                Male
              </Radio>
              <Radio
                className="inline-block"
                value="female"
                name="gender"
                onChange={this.handleRadioChange}
              >
                {" "}
                Female
              </Radio>
            </FormGroup>

            <FormGroup className="float-left col-xs-6" controlId="dogSize">
              <ControlLabel>Dog size</ControlLabel>
              <br />
              <Radio
                className="radio"
                value="small"
                id="small"
                name="size"
                onChange={this.handleRadioChange}
              >
                {"   "} Small
              </Radio>
              {"   "}
              <Radio
                className="radio"
                value="medium"
                id="medium"
                name="size"
                onChange={this.handleRadioChange}
              >
                {"   "}Medium
              </Radio>
              {"   "}
              <Radio
                className="radio"
                value="big"
                id="big"
                name="size"
                onChange={this.handleRadioChange}
              >
                {"   "}Big
              </Radio>
            </FormGroup>

            <FormGroup
              className="float-right col-xs-6 "
              controlId="dogPersonality"
            >
              <ControlLabel>Dog Personality</ControlLabel>
              <br />
              <Radio
                className="radio"
                value="shy"
                id="shy"
                name="personality"
                onChange={this.handleRadioChange}
              >
                {"   "} Shy
              </Radio>
              {"   "}
              <Radio
                className="radio"
                value="friendly"
                id="friendly"
                name="personality"
                onChange={this.handleRadioChange}
              >
                {"   "}Friendly
              </Radio>
              {"   "}
              <Radio
                className="radio"
                value="energetic"
                id="energetic"
                name="personality"
                onChange={this.handleRadioChange}
              >
                {"   "}Energetic
              </Radio>
            </FormGroup>

            <Button
              className="button-hover"
              bsSize="large"
              onClick={this.register}
              type="submit"
            >
              Go!
            </Button>
          </form>
        </div>
      </div>
    );
  }
}
